// DO NOT EDIT MANUALLY
// This file was automatically generated by `scripts/MapboxStyles/process.ts`

import { MapboxStyleLayer } from '../types'

export const mapboxStyleGroupLayers_atlas_bikelanes_smooth_default: MapboxStyleLayer[] = [
  {
    filter: ['has', 'smoothness'],
    type: 'line',
    id: 'smoothness-all',
    paint: {
      'line-color': [
        'match',
        ['get', 'smoothness'],
        ['very_bad'],
        '#d8035c',
        ['bad'],
        '#f90606',
        ['intermediate'],
        '#faa00f',
        ['good'],
        '#b5ea2e',
        ['excellent'],
        '#37f644',
        'rgba(0, 0, 0, 0)',
      ],
      'line-width': ['interpolate', ['linear'], ['zoom'], 10, 2, 14, 3, 16, 5],
      'line-offset': 1.5,
      'line-opacity': ['interpolate', ['linear'], ['zoom'], 9.9, 0, 10, 0.1, 10.3, 0.9],
    },
  },
]
